import gql from 'graphql-tag';

export const GetAccountClaimByEmailAddressCompanyId = gql`
	query GetAccountClaimByEmailAddressCompanyId(
		$emailAddress: AWSEmail!
		$companyId: ID!
	) {
		getAccountClaimByEmailAddressCompanyId(
			emailAddress: $emailAddress
			companyId: $companyId
		) {
			id
			atsId
			active
			claimed
			eligible
			companyId
			company {
				id
				theme
				symbol {
					bucket
					region
					key
				}
				background {
					bucket
					region
					key
				}
				errorImage {
					bucket
					region
					key
				}
				logo {
					bucket
					region
					key
				}
				whiteLabel
				brandColor
			}
			dateOfBirth
			emailAddress
			employeeId
			firstName
			subCompanyId
			lastName
			title
			userId
			department
			group
			customValues
			uniqueEmployeeId
		}
	}
`;
